import React from 'react';
import Header from '../component/Header'
import Footer from '../component/Footer';
import '../scss/error-page.scss' 
import FourZeroFourErrorSection from '../component/FourZeroFourErrorSection';
function FourZeroFourError() {

  return (
    <>
        <Header />       
      <main className='main error-page'>
          <div className='error-page-box'>
          <FourZeroFourErrorSection /> 
          </div>
        </main>
      <Footer />
    </>
  )
}
export default FourZeroFourError 


